import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Grid,
  MenuItem,
  Select,
  TextareaAutosize,
  Typography,
} from "@mui/material";
import Title from "../../ui/Title";
import { Card } from "../../ui/uiImport";
import { useState } from "react";
import { BulkPrintActionApi } from "../../../config/api";
import toast from "react-hot-toast";
import { TextArea } from "../../ui/TextArea";
import { StyledButton } from "../../ui/StyledButton";

export interface GSTFormData {
  idTrack: string;
  actionType_change: string;
}

const BulkPrintActions = () => {
  const [textareaValue, setTextareaValue] = useState("");

  const [formData, setFormData] = useState<GSTFormData>({
    idTrack: "awb_numbers",
    actionType_change: "label",
  });

  const downloadAwbHandler = (actionType_change: string, myArray: any) => {
    if (formData.idTrack == "awb_numbers") {
      BulkPrintActionApi({ doc_type: actionType_change, awb_numbers: myArray })
        .then((data) => {
          const downloadLink = document.createElement("a");
          downloadLink.href = URL.createObjectURL(data.data);
          downloadLink.download = `order_${actionType_change}.pdf`;
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        })
        .catch((error) => {
          toast.error(
            "Incorrect Shipment AWBs or IDs, Please enter the Correct data."
          );
        });
    } else {
      BulkPrintActionApi({ doc_type: actionType_change, shipment_ids: myArray })
        .then((data) => {
          const downloadLink = document.createElement("a");
          downloadLink.href = URL.createObjectURL(data.data);
          downloadLink.download = `order_${actionType_change}.pdf`;
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        })
        .catch((error) => {
          toast.error(
            "Incorrect Shipment AWBs or IDs, Please enter the Correct data."
          );
        });
    }
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (!textareaValue) {
      toast.error("Please Enter Order ids.");
      return;
    }
    var myArray = textareaValue.split(",");

    downloadAwbHandler(formData.actionType_change, myArray);
  };

  const handleTextareaChange = (
    event: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    setTextareaValue(event.target.value);
  };

  return (
    <>
      <Title title="Bulk Actions" />
      <Card>
        <Box sx={{ margin: "10px 0" }}>
          <Box>
            <form onSubmit={handleSubmit}>
              <Grid container mt={2} spacing={2} alignItems="center">
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth>
                    <Typography variant="subtitle1" gutterBottom>
                      Select ID for Track
                    </Typography>
                    <Select
                      labelId="idTrack-label"
                      id="idTrack-label"
                      value={formData.idTrack}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          idTrack: e.target.value,
                        })
                      }
                    >
                      <MenuItem value={"awb_numbers"}>Tracking No</MenuItem>
                      <MenuItem value={"shipment_ids"}>Order Id</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={6}>
                  <FormControl fullWidth>
                    <Typography variant="subtitle1" gutterBottom>
                      Select Action Type
                    </Typography>
                    <Select
                      labelId="actionType-label"
                      value={formData.actionType_change}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          actionType_change: e.target.value,
                        })
                      }
                    >
                      <MenuItem value={"label"}>Print Label</MenuItem>
                      <MenuItem value={"invoice"}>Print Invoice</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    Enter Comma Separated Values
                  </Typography>
                  <TextArea
                    placeholder="Example: Value 1, Value 2, Value 3"
                    fullWidth
                    value={textareaValue}
                    onChange={handleTextareaChange}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <StyledButton
                    type="submit"
                    variant="contained"
                    color="primary"
                  >
                    Submit
                  </StyledButton>
                </Grid>
              </Grid>
            </form>
          </Box>
        </Box>
      </Card>
    </>
  );
};

export default BulkPrintActions;
